import React, { Component } from 'react'
import Skeleton from 'react-loading-skeleton'

let classNames = require('classnames')

const FakeCard = ({ searchCardClass }) => {
  return (
    <div className={searchCardClass}>
      <Skeleton height={250} />
      <div className="mt-2">
        <Skeleton width={250} height={18} />
        <br />
        <Skeleton width={250} height={18} />
      </div>
      <div
        className="search-card-ratings"
        style={{ marginTop: '.25rem', color: 'rgb(238, 238, 238)' }}
      >
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
      </div>
    </div>
  )
}

export const FakeCardsArray = ({ searchCardClass }) => {
  let searchCardCount = 8
  let fakeArray = []
  for (let i = 0; i < searchCardCount; i++) {
    fakeArray.push(<FakeCard searchCardClass={searchCardClass} />)
  }
  return fakeArray
}

class SearchSkeleton extends Component {
  render() {
    const { isMobile, mapVisible, showHeader } = this.props

    let searchCardClass = classNames(
      'searchCard column',
      this.props.className,
      {
        'is-6': !isMobile && mapVisible,
        'is-3': !isMobile && !mapVisible,
        'is-12': isMobile,
      }
    )

    return (
      <React.Fragment>
        { showHeader && <Skeleton height={60} width={400} /> }
        <div className="columns is-multiline mt-4">
          <FakeCardsArray searchCardClass={searchCardClass} />
        </div>
      </React.Fragment>
    )
  }
}

export default SearchSkeleton

SearchSkeleton.defaultProps = {
  mapVisible: true,
  isMobile: false,
}
